import * as React from "react";

import { cn } from "@ui/lib/utils";
import { ReactElement } from "react";

const BASE_INPUT_CLASS_NAMES =
  "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground md:text-sm focus-visible:outline-none";

const SPECIAL_INPUT_CLASS_NAMES =
  "ring-offset-background focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          BASE_INPUT_CLASS_NAMES,
          SPECIAL_INPUT_CLASS_NAMES,
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Object.assign(Input, { displayName: "Input" });

interface IDecoratedInputProps
  extends Omit<React.ComponentProps<"input">, "prefix"> {
  prefix?: ReactElement | ReactElement[] | string | null;
  suffix?: ReactElement | ReactElement[] | string | null;
  prefixClassName?: string;
  suffixClassName?: string;
}

const DecoratedInput = React.forwardRef<HTMLInputElement, IDecoratedInputProps>(
  (
    {
      prefix,
      suffix,
      prefixClassName,
      suffixClassName,
      ...inputProps
    }: IDecoratedInputProps,
    ref
  ) => {
    const hasPrefix = !!prefix;
    const hasSuffix = !!suffix;

    return (
      <div
        className={cn(
          "flex items-center rounded-md ring-offset-background focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2",
          {
            "opacity-50 cursor-not-allowed": inputProps.disabled,
          }
        )}
      >
        {prefix && (
          <div
            className={cn(
              inputProps.className,
              BASE_INPUT_CLASS_NAMES,
              "rounded-none rounded-l-md border-r-0 w-auto",
              prefixClassName
            )}
          >
            {prefix}
          </div>
        )}
        <Input
          {...inputProps}
          ref={ref}
          className={cn(
            inputProps.className,
            "focus-visible:ring-0 focus-visible:ring-offset-0",
            {
              "rounded-none rounded-l-md": hasSuffix && !hasPrefix,
              "rounded-none": hasSuffix && hasPrefix,
              "rounded-none rounded-r-md": !hasSuffix && hasPrefix,
            }
          )}
        />
        {suffix && (
          <div
            className={cn(
              inputProps.className,
              BASE_INPUT_CLASS_NAMES,
              "items-center rounded-none rounded-r-md border-l-0 w-auto",
              suffixClassName
            )}
          >
            {suffix}
          </div>
        )}
      </div>
    );
  }
);

export { DecoratedInput, Input, type IDecoratedInputProps };
